import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Button from '../../../../../../../components/Button'
import Field from '../../../../../../../components/Form/Field'

import { formatNumber } from '../../../../../../../helpers/numbers'

import { selectedFacebookAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { BUDGET_LIFETIME } from '../../../../../../Multiplatform/UploadAdCreative/fields'

import useStepFormStyles from '../../../../../../../styles/common/stepForms'
import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const stepFields = [BUDGET_LIFETIME]

const BudgetStep = ({ formik, handleStepChange, remainingBudget }) => {
  const stepFormClasses = useStepFormStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedFacebookAdAccountSelector)

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <>
      <div className={stepFormClasses.stepTitle}>{t('What budget would you like to set for new ad set?')}</div>
      <div className={stepFormClasses.stepBody}>
        <section className={drawerFormClasses.section}>
          <div className={drawerFormClasses.sectionTitle}>{t('Lifetime Budget')}</div>
          <p>{t('A total budget for the entire run-time of the ad set.')}</p>
          <p>{t('The budget will be spent evenly over its lifetime.')}</p>
          <p>{t(`Your remaining budget is ${currencySymbol}` + formatNumber(remainingBudget, { max: 2, min: 2 }))}</p>
          <Field
            type="number"
            formik={formik}
            name={BUDGET_LIFETIME}
            placeholder={t('Lifetime Budget')}
            symbol={currencySymbol}
            autoComplete="off"
            inputMode="numeric"
          />
        </section>
      </div>
      <div className={stepFormClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default BudgetStep
